import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { dataServer, fetchDummyData } from "~/constants";
import { fetchAssetData, presentationAssets } from "~/slices/demiData";
import { fixAndParseJson } from "~/utils/utils";

export const fetchAssets = createAsyncThunk(
  "asset/fetchAssets",
  async (bids: string[] | number[] , { rejectWithValue }) => {
    if (fetchDummyData) return presentationAssets
    let time = new Date().getTime();
    let data
   
    const response = await fetch(`${dataServer}assets?bids=${bids.join(",")}`);
    if (!response.ok) {
      return rejectWithValue("Failed to fetch assets");
    }
    time = new Date().getTime() - time;
    console.log("fetchAssets time", time);
    data = await response.json();

    return data
  }
);

export const fetchAsset = createAsyncThunk(
  "asset/fetchAsset",
  async ({ bid, providerId }: { bid: number; providerId?: number | null }, { rejectWithValue }) => {
    console.log("fetchAsset bid", bid);
    let time = new Date().getTime();
    let data
    if (fetchDummyData) {
      data = fetchAssetData;
    } else {
      try {
        const response = await fetch(`${dataServer}assets/${bid}${providerId ? `?providerId=${providerId}` : ''}`);
        if (!response.ok) {
          throw new Error("Failed to fetch organization");
        }
        time = new Date().getTime() - time;
        console.log("fetchAsset time", time);
        data = await response.json();

      } catch (error: any) {
        return rejectWithValue(error.message);
      }

    }

    data.surveys = data.surveys.map((survey: any) => {
      // console.log(survey.vertical_fields)
      if (typeof survey.vertical_fields === "string") {
      let updatedSurvey = _.clone(survey);
      let verticalFields = fixAndParseJson(updatedSurvey.vertical_fields);
      verticalFields.forEach((field: any) => {
        updatedSurvey[field.field_name] = updatedSurvey[field.field];
      })
      updatedSurvey.vertical_fields = verticalFields;
      // console.log("updatedSurvey", updatedSurvey);
      return updatedSurvey;
      }
      return survey;
    });
    return data
  }
);